import {Directive, TemplateRef} from '@angular/core';

@Directive({ selector: '[storeverDatatableEmptyTemplate]' })
export class DataTableEmptyTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
